import { render, staticRenderFns } from "./goods-pinlei-dialog.vue?vue&type=template&id=c05f1a3c&scoped=true"
import script from "./goods-pinlei-dialog.vue?vue&type=script&lang=js"
export * from "./goods-pinlei-dialog.vue?vue&type=script&lang=js"
import style0 from "./goods-pinlei-dialog.vue?vue&type=style&index=0&id=c05f1a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05f1a3c",
  null
  
)

export default component.exports